import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['container']
  static values = { class: String }

  connect() {
    this.containerTarget.classList.add('opacity-0', 'transform', 'scale-95', 'transition-all', 'duration-1000', 'ease-out')
    
    this.observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this.element.classList.remove('opacity-0', 'scale-95');
          this.element.classList.add('opacity-100');
          this.observer.disconnect(); 
        }
      });
    }, { threshold: 0.2 });

    this.observer.observe(this.element);
  }

  disconnect() {
    if (this.observer) this.observer.disconnect();
  }
}
